import { useRef } from "react";

import {
  Button,
  ButtonWithPopOut,
  useButtonWithPopOut,
} from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import ReadAloudOptions from "./ReadAloudOptions";
import {
  buttonCss,
  buttonWrapperCss,
  popOutCss,
} from "./ReadAloudSpeedControl.style";

const ButtonWithPopOutWithTrackEvent = withTrackEvent(ButtonWithPopOut);

const propTypes = {
  contentId: PropTypes.string,
  currentLevelId: PropTypes.string,
  currentPlaybackRate: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  disabled: PropTypes.boolean,
  headerContentId: PropTypes.string,
  setCurrentPlaybackRate: PropTypes.func,
};

const ReadAloudSpeedControl = ({
  contentId,
  currentLevelId,
  currentPlaybackRate,
  disabled = false,
  headerContentId,
  setCurrentPlaybackRate,
}) => {
  const ariaProps = {
    "aria-label": `${currentPlaybackRate.label} read aloud speed, select to change`,
  };
  const dataProps = { "data-qa-selector": "expand-readaloud-speed-menu" };
  const buttonRef = useRef();
  const { isPopOutVisible, setIsPopOutVisible, ...controllingProps } =
    useButtonWithPopOut({ buttonRef });

  const popoutContents = (
    <ReadAloudOptions
      buttonRef={buttonRef}
      contentId={contentId}
      currentLevelId={currentLevelId}
      currentPlaybackRate={currentPlaybackRate}
      headerContentId={headerContentId}
      setCurrentPlaybackRate={setCurrentPlaybackRate}
      setIsPopOutVisible={setIsPopOutVisible}
    />
  );

  const eventProperties = {
    objectType: objectTypes.content,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.read,
    streamProperties: {
      content_type: "Article",
      description: "Show read aloud speed options",
      content_id: currentLevelId,
      article_header_content_id: headerContentId,
      article_story_content_id: contentId,
    },
  };

  return (
    <ButtonWithPopOutWithTrackEvent
      disabled={disabled}
      {...eventProperties}
      {...controllingProps}
      ariaProps={ariaProps}
      buttonContents={currentPlaybackRate?.label}
      dataProps={dataProps}
      flavor={Button.flavors.secondary}
      horizontalPopOutPosition="RIGHT"
      id="read-aloud-speed-menu"
      isPopOutVisible={isPopOutVisible}
      popOutContents={popoutContents}
      ref={buttonRef}
      setIsPopOutVisible={setIsPopOutVisible}
      __cssFor={{
        root: buttonWrapperCss,
        Button: { root: buttonCss },
        PopOut: { root: popOutCss },
      }}
    />
  );
};

ReadAloudSpeedControl.propTypes = propTypes;

export default ReadAloudSpeedControl;
